import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";
import { frFR } from "@/lib/clerk-locales/fr-FR";
import { arTN } from "@/lib/clerk-locales/ar-TN";

const appearance = {
  variables: {
    colorPrimary: "#E30613",
    colorForeground: "#111418",
    colorBackground: "#FFFFFF",
    fontFamily: "Outfit, 'IBM Plex Sans Arabic', sans-serif",
    borderRadius: "0.6rem",
  },
};

const brand = (o) => JSON.parse(JSON.stringify(o).replaceAll("{{applicationName}}", "Mohassib"));
const LOCALES = { fr: brand(frFR), ar: brand(arTN) };

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ClerkAuthProvider({ children }) {
  const navigate = useNavigate();
  const [config, setConfig] = useState(null);
  const [unavailable, setUnavailable] = useState(false);
  const [lang, setLang] = useState(localStorage.getItem("daftar_lang") || "fr");

  useEffect(() => {
    const h = (e) => setLang(e.detail);
    window.addEventListener("daftar-lang", h);
    return () => window.removeEventListener("daftar-lang", h);
  }, []);

  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg.enabled) return cancelled || setConfig(cfg);
      } catch {}
      if (cancelled) return;
      if (attempt >= 20) return setUnavailable(true);
      setTimeout(() => load(attempt + 1), 1500);
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (unavailable) return <p style={{ padding: 24 }}>Sign-in is unavailable right now. Refresh the page to try again.</p>;
  if (!config) return null;
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      localization={LOCALES[lang] || LOCALES.fr}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
      afterSignOutUrl="/"
    >
      {children}
    </ClerkProvider>
  );
}
